// @flow
import React, { type StatelessFunctionalComponent, useMemo } from "react";
import { Provider } from "react-redux";
import DocumentTitle from "react-document-title";
import configureStore from "./store";
import Notification from "../../components/Notification";
import MotivationTemplateViewContainer from "../../containers/MotivationTemplateView";

const MotivationTemplateView: StatelessFunctionalComponent<{}> = () => {
  const store = useMemo(() => configureStore());

  return (
    <DocumentTitle title="Motivation Template View">
      <Provider store={store}>
        <MotivationTemplateViewContainer />
        <Notification />
      </Provider>
    </DocumentTitle>
  );
};

export default MotivationTemplateView;
